import { UNKNOWN, sortCleanTranslate, populatePlayerPositionMap } from './utils';
import { SportName } from '@shared/enums/SportName';

const GOALKEEPER = 'goalkeeper';
const RIGHT_BACK = 'right_back';
const CENTER = 'center';
const LEFT_BACK = 'left_back';
const CIRCLE_RUNNER = 'circle_runner';
const RIGHT_WINGER = 'right_winger';
const LEFT_WINGER = 'left_winger';

export class HandballPlayerPositionHandler {
	#playerPositionsMap = {
		[GOALKEEPER]:    [],
		[RIGHT_BACK]:    [],
		[CENTER]:        [],
		[LEFT_BACK]:     [],
		[CIRCLE_RUNNER]: [],
		[RIGHT_WINGER]:  [],
		[LEFT_WINGER]:   [],
		[UNKNOWN]:       [],
	};

	constructor(players) {
		populatePlayerPositionMap(this.#playerPositionsMap, players);
	}

	getLineup() {
		return sortCleanTranslate(this.#playerPositionsMap, SportName.HANDBALL);
	}
}
